import { steps, stepsURLs } from 'constants/constants';
import { useParentOrganizationContext } from 'context/ParentOrganisationContext';
import { userAuthenticationStatus } from 'enums/AuthenticationServicesEnums';
import { CompanySetUpTabHash } from 'enums/CompanySetupEnums';
import { PrivateRouteProps } from 'enums/PrivateRouteEnums';
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import ParentCompanySetupService from 'services/ParentCompanySetup/parentCompanySetup.service';
import checkForExpiredToken from 'shared/utils/checkForExpiredToken';
import useRedirect from 'shared/utils/useRedirect';

interface PrivateRoutesProps {
  children: JSX.Element | null;
}
const PrivateRoute = ({ children }: PrivateRoutesProps) => {
  const user = localStorage.getItem(PrivateRouteProps.USER);
  const userDetails =
    user && JSON.parse(localStorage.getItem('userDetails') ?? '');

  const location = useLocation();
  const { organizationData } = useParentOrganizationContext();
  const { fetchParentOrganization } = ParentCompanySetupService();
  const { redirectToCompanyDashboard, redirectToCompanySetUp, navigate } =
    useRedirect();
  const status = userDetails?.status as userAuthenticationStatus;
  const isInactiveUser = status !== userAuthenticationStatus.ACTIVE && status;
  const redirectToLoginScreen = () => (window.location.href = '/');
  useEffect(() => {
    if (!user && location.pathname !== AppRoutes.LOGIN_VIEW) {
      redirectToLoginScreen();
      return;
    }

    if (isInactiveUser) navigate({ pathname: steps[status] });
    else if (stepsURLs.includes(window.location.pathname))
      if (organizationData?.company?.hasLocations) redirectToCompanyDashboard();
      else redirectToCompanySetUp(CompanySetUpTabHash.LOCATIONS)();
    else {
      !organizationData?.organization?.id && fetchParentOrganization();
      const isTokenExpired = checkForExpiredToken();
      if (isTokenExpired) {
        redirectToLoginScreen();
        return;
      }
    }

  }, [location.pathname]);

  if (!user || !userDetails) {
    return <Navigate to={AppRoutes.LOGIN_VIEW} />;
  } else {
    return children;
  }
};

export default PrivateRoute;
